import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	changeLocation,
	changeProductgroup,
	changeSupplier,
} from "../../services/currentInformation/actions.js";
import {
	confirmSignUpAPI,
	loginAPI,
	loginWithKey,
	signUpAPI,
} from "../../services/login/actions";
import "./SignUpForm.scss";

function SignUpForm(props) {
	const [firstname, setFirstname] = useState("");
	const [lastname, setLastname] = useState("");
	const [adres, setAdres] = useState("");
	const [zipcode, setZipcode] = useState("");
	const [city, setCity] = useState("");
	const [phonenumber, setPhonenumber] = useState("");
	const [incorrectPhoneNumberMessage, setIncorrectPhoneNumberMessage] =
		useState("");
	const [email, setEmail] = useState("");
	const [signupCode, setSignupCode] = useState(props.identifyInfo.signup_code);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [verficationViaSMS, setVerficationViaSMS] = useState("");
	let history = useHistory();

	useEffect(() => {
		if (verficationViaSMS !== "") {
			props
				.signUpAPI(
					// TODO: miss gebruik maken van combinedinfo overal
					firstname,
					lastname,
					adres,
					zipcode,
					city,
					phonenumber,
					email,
					signupCode,
					verficationViaSMS
				)
				.then((res) => {
					const combinedInfo = {
						firstname: firstname,
						lastname: lastname,
						adres: adres,
						zipcode: zipcode,
						city: city,
						phonenumber: phonenumber,
						email: email,
						signupCode: signupCode,
						verficationViaSMS: verficationViaSMS,
					};
					if (res === 404) {
						history.push({
							pathname: "/signup",
							state: { bottomNavBar: true },
						});
						window.location.reload(false);
					}
					history.push({
						pathname: "/confirmsignup",
						state: {
							phonenumber: phonenumber,
							key: res.key,
							message: res.message,
							combinedInfo: combinedInfo,
						},
					});
				});
		}
	}, [verficationViaSMS]);

	const handleSubmit = (event) => {
		event.preventDefault();
		if (isValidPhoneNumber(phonenumber)) {
			setDialogOpen(true);
		} else {
			setIncorrectPhoneNumberMessage("Dit nummer is niet valide");
		}
		//ONLY IF GOOD!
		//history.push({pathname:"/confirmsignup", state:{phonenumber:phonenumber}});
		//props.confirmSignUpAPI(phonenumber,props.signupKey)
	};

	const getCorrectLogo = () => {
		if (props.logo == undefined) {
			return props.identifyInfo.logo;
		} else {
			return props.logo;
		}
	};

	return (
		<div className="LoginFormWrapper">
			<div className="LoginFormBackground"></div>
			<div className="LoginForm fadeIn">
				<div>
					<img src={getCorrectLogo()}></img>
				</div>
				<form onSubmit={handleSubmit}>
					<p>Meld u aan bij Easy-Dish</p>
					<input
						className="LoginFormInput"
						type="name"
						placeholder="Voornaam"
						onChange={(e) => setFirstname(e.target.value)}
						required
						autoFocus
					/>
					<input
						className="LoginFormInput"
						type="name"
						placeholder="Achternaam"
						onChange={(e) => setLastname(e.target.value)}
						required
					/>
					<input
						className="LoginFormInput"
						type="text"
						placeholder="Adres"
						onChange={(e) => setAdres(e.target.value)}
						required
					/>
					<input
						className="LoginFormInput"
						type="text"
						placeholder="Postcode"
						onChange={(e) => setZipcode(e.target.value)}
						required
					/>
					<input
						className="LoginFormInput"
						type="text"
						placeholder="Stad"
						onChange={(e) => setCity(e.target.value)}
						required
					/>
					<div className="LoginFormInput">
						<PhoneInput
							defaultCountry="NL"
							placeholder="Telefoonnummer"
							value={phonenumber}
							onChange={setPhonenumber}
							required
						/>
					</div>
					{
						<p style={{ color: "red", margin: 0 }}>
							{incorrectPhoneNumberMessage}
						</p>
					}
					<input
						className="LoginFormInput"
						type="email"
						placeholder="Email adres"
						onChange={(e) => setEmail(e.target.value)}
						required
					/>
					<input
						className="LoginFormSubmit"
						type="submit"
						value="Maak account aan"
					/>
					<Dialog
						open={dialogOpen}
						onClose={() => setDialogOpen(false)} // makes it possible to click outside the dialog window to close it
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
					>
						<DialogTitle id="alert-dialog-title">
							{"Hoe wilt u de verificatiecode ontvangen"}
						</DialogTitle>
						<DialogActions style={{ justifyContent: "space-evenly" }}>
							<Button
								onClick={() => setVerficationViaSMS("false")}
								color="primary"
								autoFocus
							>
								Per mail
							</Button>
							<Button
								onClick={() => setVerficationViaSMS("true")}
								color="primary"
							>
								Per sms
							</Button>
						</DialogActions>
					</Dialog>
				</form>
			</div>
		</div>
	);
}
//}

function mapStateToProps(state) {
	return {
		loginSuccesful: state.login.data.loginSuccesful,
		userId: state.login.data.user_id,
		currentLocation: state.login.data.current_location,
		suppliers: state.assortiment.suppliers,
		currentSupplier: state.currentInformation.current_supplier,
		signupInfo: state.login.signupInfo,
		identifyInfo: state.identify.identifyInfo,
		logo: state.login.data.logo,
	};
}

export default connect(mapStateToProps, {
	confirmSignUpAPI,
	signUpAPI,
	loginAPI,
	loginWithKey,
	changeSupplier,
	changeProductgroup,
	changeLocation,
})(SignUpForm);
